(function () {
    angular.module('agweb').controller('SearchController', ['$scope', '$http', '$timeout', '$filter',
        function ($scope, $http, $timeout, $filter) {
            var ctrl = this;

            var _q = tios.util.parseQuery(null, true);

            var _searchTO = null;

            var _sF = tios.util.getFromStorage('filters', true);
            var _sSort = tios.util.getFromStorage('sort', true);
            var _sC = tios.util.getFromStorage('checks', true);

            const PROVIDER = new GeoSearch.OpenStreetMapProvider({
                params: {
                    countrycodes: 'gb'
                }
            });

            var _priceArr = [
                ...tios.util.fillArray(15, 50000, 25000),
                ...tios.util.fillArray(12, 450000, 50000),
                ...tios.util.fillArray(4, 1250000, 250000),
                ...tios.util.fillArray(3, 3000000, 1000000)
            ].map(function (item) {
                return { label: $filter('currency')(item, '£', 0), int: item };
            });

            var _rentArr = [
                ...tios.util.fillArray(10, 400, 50),
                ...tios.util.fillArray(11, 900, 100),
                ...tios.util.fillArray(7, 2000, 500)
            ].map(function (item) {
                return { label: $filter('currency')(item, '£', 0), int: item };
            });

            //checks if storage, if there is use set the filters to the stored values otherwise set to default.
            ctrl.filters = {};
            ctrl.preFilters = {
                Lat: !!_sF ? _sF.Lat : (!!_q.Lat ? parseFloat(_q.Lat) : null),
                Long: !!_sF ? _sF.Long : (!!_q.Long ? parseFloat(_q.Long) : null),
                Label: !!_sF ? _sF.Label : (!!_q.Label ? _q.Label : ''),
                Radius: !!_sF ? _sF.Radius : (!!_q.Radius ? parseFloat(_q.Radius) : 2),
                BedroomsMin: !!_sF ? _sF.BedroomsMin : (!!_q.BedroomsMin ? parseInt(_q.BedroomsMin) : null),
                PriceMin: !!_sF ? _sF.PriceMin : (!!_q.PriceMin ? parseInt(_q.PriceMin) : null),
                PriceMax: !!_sF ? _sF.PriceMax : (!!_q.PriceMax ? parseInt(_q.PriceMax) : null),
                AddedToSite: !!_sF ? _sF.AddedToSite : (!!_q.AddedToSite ? parseFloat(_q.AddedToSite) : 0),
                PropertyType: !!_sF ? _sF.PropertyType : (!!_q.PropertyType ? _q.PropertyType : null),
                IncludeSSTC: !!_sF ? _sF.IncludeSSTC : false,
                Lettings: !!_sF ? _sF.Lettings : !!_q.Lettings,
                TerritoryID: !!_sF ? _sF.TerritoryID : (!!_q.TerritoryID ? _q.TerritoryID : null),
                Prestige: !!_q.Prestige,
                Parking: !!_sF ? _sF.Parking : null,
                Situation: !!_sF ? _sF.Situation : null,
                Special: !!_sF ? _sF.Special : null,
                Garage: !!_sF ? _sF.Garage : false
            };

            ctrl.sort = {
                Sort: !!_sSort ? _sSort.Sort : 'highLow',
                propListMax: !!_sSort ? _sSort.propListMax : 10,
                Code: !!_sSort ? _sSort.Code : null
            };

            ctrl.checks = {};
            ctrl.preChecks = {
                garden: !!_sC ? _sC.garden : false,
                annexe: !!_sC ? _sC.annexe : false,
                garage: !!_sC ? _sC.garage : false,
                conservatory: !!_sC ? _sC.conservatory : false,
                land: !!_sC ? _sC.land : false,
                tennis: !!_sC ? _sC.tennis : false,
                swimming: !!_sC ? _sC.swimming : false,
                outbuilding: !!_sC ? _sC.outbuilding : false,
                offstreet: !!_sC ? _sC.offstreet : false,
                equestrian: !!_sC ? _sC.equestrian : false,
                residents: !!_sC ? _sC.residents : false
            };

            ctrl.checkCanClear = function () {
                for (var key in ctrl.preFilters) {
                    if (key !== 'Radius') {
                        if (ctrl.preFilters[key]) {
                            return true; 
                        }
                    }
                }
            };

            ctrl.ux = {
                searchTab: 'location',
                fixSearch: false,
                expandSearch: false,
                canClear: ctrl.checkCanClear(),
                // Map
                showMap: false,
                mapRadius: 0,
                //Types
                typeCount: 'All',
                showMustHaves: false,
                // Sort by
                sort: 'highLow',
                orderBy: 'p',
                reverse: true,
                territory: '',
                // scroll pos
                fromBack = false
            };

            // check for data in storage produced by clicking "View";
            if (!!_sF && !!_sSort) {
                ctrl.ux.fromBack = true; // tells the search page that it has come back from a property details page. 
                tios.util.removeFromStorage('filters', true); // storage is emptied upon as storage is stored in sF var so actual storage doesn't need maintaining. 
                tios.util.removeFromStorage('sort', true); 
                tios.util.removeFromStorage('checks', true); 

                if (!!_q.Lettings !== !!_sF.Lettings) _sF = null;
            }

            ctrl.mustHave = [
                { label: 'parking' },
                { label: 'garden' },
                { label: 'ensuite' },
                { label: 'garage' },
                { label: 'driveway' }
            ];

            ctrl.particular = Object.values(enums.PropertyTypeValues);

            ctrl.sortList = [
                { model: 'highLow', label: 'Price high to low' },
                { model: 'lowHigh', label: 'Price low to high' },
                { model: 'recent', label: 'Most recent first' }
            ];

            ctrl.radii = [
                { label: '+1/2 mile', radius: 0.5 },
                { label: '+1 mile', radius: 1 },
                { label: '+2 miles', radius: 2 },
                { label: '+5 miles', radius: 5 },
                { label: '+10 miles', radius: 10 },
                { label: '+15 miles', radius: 15 },
                { label: '+20 miles', radius: 20 }
            ];

            ctrl.pricesLow = !!ctrl.preFilters.Lettings ? angular.copy(_rentArr) : angular.copy(_priceArr);
            ctrl.pricesHigh = !!ctrl.preFilters.Lettings ? angular.copy(_rentArr) : angular.copy(_priceArr);

            ctrl.added = [
                { label: 'Anytime', int: 0 },
                { label: 'Last 24 hours', int: 1 },
                { label: 'Last week', int: 7 },
                { label: 'Last Month', int: 30 }
            ];

            ctrl.isMobile = tios.util.isMobile();

            //-
            ctrl.areaSearch = function (event) {
                ctrl.clearGeoArea();
                ctrl.ux.searching = !!event.string;
                if (!!_searchTO) $timeout.cancel(_searchTO);
                _searchTO = $timeout(function () {
                    PROVIDER.search({ query: event.string })
                        .then(function (response) {
                            $scope.$applyAsync(() =>
                                ctrl.areaResults = response.filter(r => r.raw.class === 'place' ||
                                    r.raw.class === 'boundary'));
                        });
                }, 300);
            };

            function _hasFilter() {
                for (prop in ctrl.preFilters) {
                    if (prop !== 'Radius' && !!ctrl.preFilters[prop]) return true;
                }
                return false;
            }

            function _clickOffMap(event) {
                if (!event.target.closest(".map-trigger") && !event.target.closest(".results")) {
                    $scope.$applyAsync(function () {
                        ctrl.ux.showMap = false;
                        document.removeEventListener('click', _clickOffMap);
                    });
                }
            }

            ctrl.openMap = function () {
                ctrl.ux.showMap = true;

                document.addEventListener('click', _clickOffMap);
            };

            ctrl.selectGeoArea = function (event) {
                // Update the selection for the map view
                ctrl.preFilters.Lat = event.item.y;
                ctrl.preFilters.Long = event.item.x;
                ctrl.preFilters.Label = event.item.label;
                ctrl.preFilters.Radius = 2;

                ctrl.ux.searching = false;
                ctrl.ux.showMap = true;
                ctrl.ux.setGeoArea = true;

                ctrl.ux.canClear = true;

                document.addEventListener('click', _clickOffMap);
            };

            ctrl.clearGeoArea = function () {
                ctrl.preFilters.Lat = null;
                ctrl.preFilters.Long = null;
                ctrl.preFilters.Label = '';
                ctrl.preFilters.Radius = 2;

                ctrl.ux.showMap = false;
                ctrl.ux.setGeoArea = false;

                ctrl.ux.canClear = _hasFilter();

                document.removeEventListener('click', _clickOffMap);
            };

            function _setRadius() {
                $scope.$applyAsync(() => ctrl.ux.mapRadius = Math.round(ctrl.preFilters.Radius * 1609.344));
            }

            ctrl.selectFilter = function (event, filter) {
                switch (filter) {
                    case 'priceMin':
                        ctrl.preFilters.PriceMin = event.item.int;
                        if (event.item.int > ctrl.preFilters.PriceMax) ctrl.preFilters.PriceMax = null;
                        break;
                    case 'priceMax':
                        ctrl.preFilters.PriceMax = event.item.int;
                        if (event.item.int < ctrl.preFilters.PriceMin) ctrl.preFilters.PriceMin = null;
                        break;
                    case 'added':
                        ctrl.preFilters.AddedToSite = event.item.int;
                        break;
                    case 'radius':
                        ctrl.preFilters.Radius = event.item.radius;
                        _setRadius();
                        break;
                    case 'propertyType':
                        ctrl.preFilters.PropertyType = event.item.Name;
                        break;
                    case 'sstc':
                        ctrl.preFilters.IncludeSSTC = event.value;
                        break;
                }
                ctrl.ux.canClear = (!filter || filter !== 'beds' || !!ctrl.preFilters.BedroomsMin);
            };

            ctrl.selectSort = function (event) {
                var ob = null;
                var rv = false;

                if (!event) {
                    ctrl.ux.sort = ctrl.sort.Sort;
                } else {
                    ctrl.sort.Sort = event.item.model;
                    ctrl.ux.sort = event.item.model;
                }

                switch (ctrl.ux.sort) {
                    case 'highLow':
                        // Set the rv bool then drop through to the next case
                        // without breaking as the ob is the same.
                        rv = true;
                    case 'lowHigh':
                        ob = 'p';
                        break;
                    case 'recent':
                        ob = 'd';
                        rv = true;
                        break;
                }
                $scope.$applyAsync(function () {
                    ctrl.ux.orderBy = ob;
                    ctrl.ux.reverse = rv;
                });
            };

            ctrl.storeFilters = function (code) {
                tios.util.saveToStorage('filters', ctrl.filters, true);
                tios.util.saveToStorage('sort', ctrl.sort, true);
                tios.util.saveToStorage('checks', ctrl.checks, true);
            };

            function _clickOff(event) {
                if (!event.target.closest(".must-haves-trigger")) {
                    $scope.$applyAsync(function () {
                        ctrl.ux.showMustHaves = false;
                        document.removeEventListener('click', _clickOff);
                    });
                }
            }

            ctrl.showMustHaves = function () {
                ctrl.ux.showMustHaves = !ctrl.ux.showMustHaves;
                if (ctrl.ux.showMustHaves) {
                    document.addEventListener('click', _clickOff);
                } else {
                    document.removeEventListener('click', _clickOff);
                }
            };

            function getCheckCount() {
                return Object.values(ctrl.preChecks).filter(item => !!item).length;
            }

            ctrl.updateMustHaves = function (event, type, check, flagValue) {
                switch (type) {
                    case 'Garage':
                        ctrl.preFilters.Garage = event.value;
                        ctrl.preChecks.garage = event.value;
                        break;
                    case 'Situation':
                        ctrl.preFilters.Situation ^= flagValue;
                        break;
                    case 'Special': Object.values(ctrl.preFilters).find(item => !!item)
                        ctrl.preFilters.Special ^= flagValue;
                        break;
                    case 'Parking':
                        ctrl.preFilters.Parking ^= flagValue;
                        break;
                }
                ctrl.preChecks[check] = event.value;
                ctrl.ux.canClear = _hasFilter() || getCheckCount();
            };

            ctrl.getMustHaveLabel = function () {
                var checks = getCheckCount();
                return 'Must have' + (!!checks ? ' (' + checks + ')' : '');
            };

            ctrl.search = function (event, reset) {
                if (!!reset) {
                    ctrl.preFilters = {
                        Lat: null,
                        Long: null,
                        Label: '',
                        Radius: 2,
                        BedroomsMin: null,
                        PriceMin: null,
                        PriceMax: null,
                        AddedToSite: 0,
                        PropertyType: null,
                        IncludeSSTC: false,
                        Lettings: !!_q.Lettings,
                        TerritoryID: !!_q.TerritoryID ? _q.TerritoryID : null,
                        Prestige: !!_q.Prestige,
                        Parking: null,
                        Situation: null,
                        Special: null,
                        Garage: false
                    };
                    ctrl.sort = {
                        Sort: 'highLow',
                        propListMax: 10,
                        Code: null
                    };
                    ctrl.preChecks = {
                        garden: false,
                        annexe: false,
                        garage: false,
                        conservatory: false,
                        land: false,
                        tennis: false,
                        swimming: false,
                        outbuilding: false,
                        offstreet: false,
                        equestrian: false,
                        residents: false
                    };
                    ctrl.ux.canClear = false;
                }
                ctrl.filters = angular.copy(ctrl.preFilters);
                ctrl.checks = angular.copy(ctrl.preChecks);

                ctrl.preFilters.Situation = ctrl.preFilters.Situation || null;
                ctrl.preFilters.Special = ctrl.preFilters.Special || null;
                ctrl.preFilters.Parking = ctrl.preFilters.Parking || null;

                ctrl.ux.showMap = false;
                ctrl.ux.expandSearch = false;
                ctrl.ux.setGeoArea = false;

                $http({
                    url: urls.Api + 'Property/Search',
                    method: 'POST',
                    data: ctrl.preFilters
                }).then(function success(response) {
                    var rd = response && response.data;
                    if (!!rd) {

                        ctrl.results = rd.Items;

                        ctrl.ux.territory =
                            ctrl.preFilters.TerritoryID ?
                                rd.Territories.find(item => item.TerritoryID === ctrl.preFilters.TerritoryID.toLowerCase()).Location :
                                '';

                        _setRadius();

                        if (!event) { ctrl.selectSort() } // event is click on "FindProperties" 
                        $timeout(function () {
                            if (event) {
                                ctrl.sort.propListMax = 10;  // if findproperties button clicked reset list to 10 and scroll top 
                                document.scrollingElement.scrollTop = 0;
                            } else if (ctrl.ux.fromBack) { // if findproperties is not clicked and you have come back from property details find the clicked and scroll to it 
                                document.getElementById('listing-' + ctrl.sort.Code).scrollIntoView(); //each property in list has id = to property code. 
                            }
                        }, 500);
                    }
                });
            };

            ctrl.scrollPos = 0;
            ctrl.showMore = function () {

                ctrl.scrollPos = window.scrollY;

                ctrl.sort.propListMax = ctrl.sort.propListMax + 10;

                $timeout(function () {
                    window.scrollTo(0, ctrl.scrollPos);
                });

            };

            ctrl.viewPropertyURL = function (item, highfields) {
                if (highfields) {
                    return urls.Microsites_Highfields_Index;
                } else {
                    return urls.PropertyDetail + item.c + (ctrl.preFilters.Lettings ? '?Lettings=true' : (ctrl.preFilters.Prestige ? '?Prestige=true' : ''));
                }
            };

            ctrl.viewProperty = function (item) {
                ctrl.sort.Code = item.c;
                ctrl.storeFilters(); // stores filters in session storage
                return false;
            };

            $scope.$on('$destroy', function () {
                document.removeEventListener('click', _clickOff);
                document.removeEventListener('click', _clickOffMap);

            });

            //-i

            ctrl.search();
        }
    ]);
})();